/**
 * 公共背景 Mixin
 * 统一处理 Unsplash 背景图获取、粒子样式计算、加载动画
 * 所有页面组件共用，避免重复代码
 */
export default {
  data() {
    return {
      fullImageURL: '',
      isLoaded: false,
    }
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: this.fullImageURL
          ? `url(${this.fullImageURL})`
          : 'linear-gradient(135deg, var(--color-bg-deep) 0%, var(--color-bg-mid) 50%, var(--color-bg-top) 100%)',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }
    }
  },
  methods: {
    // 通过后端代理获取 Unsplash 随机图片，避免前端暴露 API Key
    async fetchBackground() {
      try {
        const res = await this.$axios.get('/api/unsplash/random');
        if (res.data && res.data.url) {
          this.fullImageURL = res.data.url;
        }
      } catch (error) {
        // 静默降级，使用渐变背景
        console.warn('背景图加载失败，使用默认渐变');
      }
    },
    // 粒子样式随机生成
    getParticleStyle() {
      const size = Math.random() * 3 + 1;
      const left = Math.random() * 100;
      const duration = Math.random() * 15 + 10;
      const delay = Math.random() * 15;
      const opacity = Math.random() * 0.4 + 0.1;
      return {
        width: `${size}px`,
        height: `${size}px`,
        left: `${left}%`,
        animationDuration: `${duration}s`,
        animationDelay: `-${delay}s`,
        opacity,
      }
    },
    // 统一的加载入场动画
    triggerLoadAnimation() {
      setTimeout(() => {
        this.isLoaded = true;
      }, 100);
    }
  },
  mounted() {
    this.fetchBackground();
    this.triggerLoadAnimation();
  }
}
